module.exports = "/virtual-football-league/img/amblems/right/logos/REAL MADRID.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/REAL MADRID.png
// module id = 2221
// module chunks = 4